<template>
  <div class="main-content main-content-404 right-sidebar">
    <div class="container">
      <div class="row">
        <div
          class="content-area content-404 col-lg-12 col-md-12 col-sm-12 col-xs-12"
        >
          <div class="site-main">
            <section class="error-404 not-found">
              <div class="images">
                <img src="assets/images/404.png" alt="img" />
              </div>
              <div class="text-404">
                <h1 class="page-title">
                  Error 404 Not Found
                </h1>
                <p class="page-content">
                  Lo sentimos, no se pudo encontrar la página que buscas.
                  <br />
                  Puedes volver a
                  <a href="index-2.html" class="hightlight"> Home page</a>
                  o usando
                  <span class="hightlight toggle-hightlight">
                    buscar
                  </span>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
